import React, { Dispatch, SetStateAction } from 'react';
import { useInView } from 'react-intersection-observer';
import {
  Grid, Heading, Container, Link,
} from '@printdeal/ui-library';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Link as GatsbyLink } from 'gatsby';
import { dispatchDataLayerProductImpressions } from '../../helpers/dataLayerHelpers/CategoryPageDataLayerHelper';
import ProductSectionCard from './ProductSectionCard';
import { ProductSection, QuickViewModalState } from './ProductsSection';
import { dispatchDataLayerEntry } from '../../helpers/dataLayerHelpers/productDataLayerHelper';
import { ExploreDesignTemplateButton } from '../design-template/exploreDesignTemplateButton';

interface Props {
  categoryName: string,
  group: ProductSection,
  groupIndex: number,
  setQuickViewModal: Dispatch<SetStateAction<QuickViewModalState | null>>
  isQuickViewExp: boolean;
}

const ProductGroupSection = ({
  categoryName, group, groupIndex, setQuickViewModal, isQuickViewExp,
}: Props) => {
  const {
    id: sectionId, title: sectionTitle, description, readMoreLinkText, readMoreLink,
  } = group;
  const { ref } = useInView({
    triggerOnce: true,
    onChange: (inView) => inView && dispatchDataLayerProductImpressions(sectionTitle || categoryName, group.products),
  });

  const sendReadMoreClickEvent = () => {
    dispatchDataLayerEntry(
      'show_more_link_shop-in-shop_sections',
      'click',
      {
        link_text: readMoreLinkText,
        link_url: readMoreLink?.path,
      },
    );
  };

  return (
    <Container ref={ref} id={sectionId}>
      {(sectionTitle || description) && (
      <div className="pd-mb-6">
        {sectionTitle && (
        <div className="pd-flex pd-justify-between">
          <div className="pd-flex pd-gap-4">
            <Heading as="h2">{sectionTitle}</Heading>
            <ExploreDesignTemplateButton label="category_link" isButton={false} />
          </div>
          {readMoreLinkText && readMoreLink?.path && (
          <Link
            to={readMoreLink.path}
            onClick={sendReadMoreClickEvent}
            variant="secondary"
            iconAfter="chevron-right"
            className="pd-text-xs"
            as={GatsbyLink}
          >
            {readMoreLinkText}
          </Link>
          )}
        </div>
        )}
        {description && <p>{description}</p>}
      </div>
      )}
      <div className="pd-mx-auto">
        <Grid className="pd-grid-cols-2 pd-gap-6 md:pd-grid-cols-3 lg:pd-grid-cols-4">
          {group.products.map((groupItem, index) => (
            <ProductSectionCard
              key={groupItem.id}
              categoryPage={categoryName}
              product={groupItem}
              productIndex={index}
              setQuickViewModal={setQuickViewModal}
              lazyLoad={groupIndex !== 0 || (groupIndex > 0 && index > 3)}
              isQuickViewExp={isQuickViewExp}
            />
          ))}
        </Grid>
      </div>
    </Container>
  );
};

export default ProductGroupSection;
